<template>
	<div v-if="intranetUser">
		<nk-title size="xl" font-weight="bold">
			Guten Tag, {{ intranetUser.vorname }} {{ intranetUser.nachname }}
		</nk-title>
		<nk-sidebar-submenu
			v-if="context.menuItems"
			:context="{menuItems: context.menuItems, title: null}"
		/>
		<div v-else-if="intranetRubriken && intranetRubriken.length">
			<nk-nav class="my-5" aria-label="Intranet Navigation">
				<nk-nav-item
					v-for="(intranetRubrik, index) in intranetRubriken"
					:key="index"
					:link="intranetRubrik.taggingpfad"
				>
					{{ intranetRubrik.rubrik }}
				</nk-nav-item>
			</nk-nav>
		</div>

		<nk-wrapper>
			<nk-button link="/intranet/passwortaendern/" expand color="secondary">
				Passwort ändern
			</nk-button>
		</nk-wrapper>

		<nk-template-intranet-logout />
	</div>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';
import {useIntranet, fetchIntranetRubriken} from '#nk/composables/intranet';

export default {
	mixins: [TemplatesDefault],
	async setup() {
		const {rubriken, user} = useIntranet();
		if (user.value) await fetchIntranetRubriken();

		return {
			intranetRubriken: rubriken,
			intranetUser: user,
			TemplatesDefault,
		};
	},
};
</script>
